import { api } from "@/lib/api";
import { type Schemas } from "@/types";
import { useQuery } from "react-query";

export default function OpenLeadsTabQuery() {
  const { data } = useQuery({
    queryKey: ["openLeadsTabStats"],
    queryFn: async () => {
      const response = await api.get<Schemas["OpenLeadsTabStats"]>(
        "/api/Reports/OpenLeadsTabStats",
      );
      return response.data;
    },
  });

  return {
    totalCount: data?.totalOpenLeads,
  };
}
